import React from 'react';
import { useDesign } from '../../contexts/DesignContext';
import { useTranslation } from 'react-i18next';
import './DesignSwitcher.css';

function DesignSwitcher() {
  const { designStyle, toggleDesignStyle } = useDesign();
  const { t } = useTranslation();
  const isPremium = designStyle === 'premium';
  const label = isPremium
    ? t('designSwitcher.switchToClassic')
    : t('designSwitcher.switchToAlternative');
  const buttonText = isPremium
    ? t('designSwitcher.classicLabel')
    : t('designSwitcher.alternativeLabel');

  return (
    <button
      type="button"
      onClick={toggleDesignStyle}
      aria-label={label}
      title={label}
      className="design-switcher"
    >
      <span aria-hidden="true">{buttonText}</span>
    </button>
  );
}

export default DesignSwitcher;
